import {Switch} from '@wandb/weave/components';
import React, {useState} from 'react';

import {
  useMediaPixelatedDisplay,
  useShouldShowMediaPixelatedResetAtLevel,
} from '../../hooks';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsContext} from '../contexts/MediaSettingsContextProvider';

export const SmoothImage = () => {
  const {updateConfig, unsetConfigField, settingsLevel, panelRef} =
    useMediaSettingsContext();
  const pixelated = useMediaPixelatedDisplay(settingsLevel, panelRef);
  const isSetAtLevel = useShouldShowMediaPixelatedResetAtLevel(
    settingsLevel,
    panelRef
  );
  const [shouldSmoothImage, setShouldSmoothImage] = useState(!pixelated);
  return (
    <div className="flex items-center justify-between">
      <SettingTitle
        title="Smooth image"
        description="Improve visibility of image"
        configField="pixelated"
        isDirty={isSetAtLevel}
        unsetConfigField={() => unsetConfigField('pixelated')}
      />
      <Switch.Root
        aria-label="Toggle smooth image"
        data-test="smooth-image-switch"
        checked={shouldSmoothImage}
        onCheckedChange={newValue => {
          setShouldSmoothImage(newValue);
          updateConfig({pixelated: !newValue});
        }}>
        <Switch.Thumb checked={shouldSmoothImage} />
      </Switch.Root>
    </div>
  );
};
